import { MaestroApi } from './api';

export default async function fetchOwnerData({ accessToken }) {
	const res = await MaestroApi.get('/user', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data || [];
}
